import { contactUsMessages } from './contactUsMessages'
import { dealerContactMessages } from './dealerContactMessages'
import { feedback } from './feedback'
import { recentlyViewed } from './recentlyViewed'
import { savedSearches } from './savedSearches'
import { savedVehicles } from './savedVehicles'
import { toggleDisableUser, updatePostVehicleLimit, userDetail, userSearch } from './user'
import { searchPrivateVehicle, toggleDisableVehicle, vehicleDetail } from './vehicle'

export const cruzApi = {
  user: {
    search: userSearch,
    detail: userDetail,
    toggleDisable: toggleDisableUser,
    updatePostVehicleLimit: updatePostVehicleLimit,
  },
  vehicle: {
    search: searchPrivateVehicle,
    detail: vehicleDetail,
    toggleDisable: toggleDisableVehicle,
  },
  contactUsMessages,
  dealerContactMessages,
  feedback,
  savedVehicles,
  savedSearches,
  recentlyViewed,
}
